import { useState } from "react";

/**
 * Promise-based <ConfirmDialogue />: `await openConfirm({ title, message, confirmText, variant, icon })` resolves to
 * true / false. Render `{confirmData.isOpen && <ConfirmDialogue confirmData={confirmData} handleConfirmClose={handleConfirmClose} />}`.
 */
export default function useConfirm() {
  const [confirmData, setConfirmData] = useState({ isOpen: false });

  const openConfirm = (options) => new Promise((resolve) => setConfirmData({ cancelText: "Cancel", ...options, isOpen: true, resolve }));
  const handleConfirmClose = (result) => {
    confirmData.resolve?.(result);
    setConfirmData({ isOpen: false });
  };

  return { confirmData, openConfirm, handleConfirmClose };
}
